class ProductVariations extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-product-handle', 'data-collection-handle']
  }
}

if (!customElements.get('product-variations')) {
  customElements.define('product-variations', ProductVariations)
}
 
class ProductVariation extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return [
      'data-filter-by',
      'data-current-option-name',
      'data-current-option-value',
      'data-current-option-value-handleized',
    ]
  }

  static get requiredElements () {
    return ['options']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.options?.element) return

    this.render()
  }

  async render () {
    const html = await this.variationOptionHTML()

    if (!html.length) {
      this.remove()
      return
    }

    this.els.options.element.innerHTML = html
  }

  async variationOptionHTML () {
    var { currentOptionName, filterBy } = this.dataset
    
    console.log("FILTER", currentOptionName, this.productVariationsEl.dataset.collectionHandle, filterBy);

    filterBy = (filterBy || '').replaceAll('&amp;', '&');

    const html =
      window.sessionStorage.getItem(this.storageKey) ||
      (await window.BAO.sectionRenderer.fetchSingle(
        `product-variation-options-${currentOptionName}`,
        `/collections/${this.productVariationsEl.dataset.collectionHandle}?${filterBy}`,
      ))

    window.sessionStorage.setItem(this.storageKey, html)

    return window.BAO.sectionRenderer.getInnerHtml(html)
  }

  get productVariationsEl () {
    return this.closest('product-variations')
  }

  get storageKey () {

    const raw = (this.dataset.filterBy || '').replaceAll('&amp;', '&')
    
    // A short, stable hash avoids very long keys; btoa is fine here.
    let hash
    try {
      hash = btoa(unescape(encodeURIComponent(raw))).slice(0, 24)
    } catch (e) {
      hash = raw.slice(0, 24) // fallback
    }

    return `${this.productVariationsEl.dataset?.productHandle}-${this.dataset.currentOptionName}-${hash}`
  }
}

if (!customElements.get('product-variation')) {
  customElements.define('product-variation', ProductVariation)
}

class ProductVariationOption extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-option-name', 'data-option-value-handleized']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.productVariationEl) return

    const { currentOptionName, currentOptionValueHandleized } =
      this.productVariationEl.dataset
    const { optionName, optionValueHandleized } = this.dataset

    const isCurrent =
      currentOptionName === optionName &&
      currentOptionValueHandleized === optionValueHandleized

    this.toggleAttribute('active', isCurrent)
  }

  get productVariationEl () {
    return this.closest('product-variation')
  }
}

if (!customElements.get('product-variation-option')) {
  customElements.define('product-variation-option', ProductVariationOption)
}

class ProductVariationSelect extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['value', 'select']
  }

  sortOptionsNumeric() {
    const select = this.querySelector('[data-product-variation-select-el="select"]');
    if (!select) return;

    // Keep currently selected value so we can restore it after reordering
    const currentValue = select.value;

    // Turn NodeList into array and sort numerically by the option label
    const options = Array.from(select.querySelectorAll('option'));

    // Helper: pull the first numeric token we can find (works for "5.0", "165.0", "2m x 3m")
    const num = (opt) => {
      const source =
        (opt.textContent || opt.innerText || '').trim() ||
        opt.getAttribute('data-option-value-handleized') ||
        '';
      const match = source.match(/[\d]+(?:\.\d+)?/); // first number like 5, 10.0, 2.5
      return match ? parseFloat(match[0]) : Number.POSITIVE_INFINITY;
    };

    options.sort((a, b) => num(a) - num(b));

    // Rebuild the <select> in sorted order
    select.innerHTML = '';
    options.forEach((o) => select.appendChild(o));

    // Restore selection if possible
    if (currentValue) {
      select.value = currentValue;
    }
  }


  connectedCallback () {
    super.connectedCallback()

    this.renderCurrentValue()
    this.setSelectedOption()

    this.sortOptionsNumeric()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.selectEl) return

    this.listeners.add(this.selectEl, 'change', this.handleChange.bind(this))
  }

  renderCurrentValue () {
    const currentOptionValue =
      this.productVariationEl?.dataset?.currentOptionValue

    if (!this.valueEl || !currentOptionValue) return

    this.valueEl.textContent = currentOptionValue
  }

  setSelectedOption () {
    console.log('options' + this.productVariationEl, this.selectEl)
    if (!this.productVariationEl || !this.selectEl) return

    const optionEls = this.selectEl?.options || []

    const { currentOptionName, currentOptionValueHandleized } =
      this.productVariationEl.dataset

    const selectedOptionEl = [...optionEls].find((optionEl) => {
      const { optionName, optionValueHandleized } = optionEl.dataset

      return (
        currentOptionName === optionName &&
        currentOptionValueHandleized === optionValueHandleized
      )
    })

    if (!selectedOptionEl) return

    selectedOptionEl.selected = true
  }

  handleChange (event) {
    const { value } = event.target

    if (!value?.length) return

    window.location.href = value
  }

  get productVariationEl () {
    return this.closest('product-variation')
  }

  get valueEl () {
    return this.els?.value?.element
  }

  get selectEl () {
    return this.els?.select?.element
  }
}

// console.log('page' + customElements.get('product-variation-select'))

if (!customElements.get('product-variation-select')) {
  customElements.define('product-variation-select', ProductVariationSelect)
}
